import { filteredTaxRegimeByIncomeCategory, filteredIncomeCategoryByTaxRegime } from "@/types/tax/taxSystems.types";
import { FormSelectOption } from "@/types/formSelectOption.types";

export function getIncomeCategoriesByTaxRegime ( allIncomeCategories: FormSelectOption[], selectedTaxRegime: string | null): FormSelectOption[] {
    if (!selectedTaxRegime) return allIncomeCategories

    const allowed = filteredIncomeCategoryByTaxRegime[selectedTaxRegime] || []
    return allIncomeCategories.filter(
        income => income.id === '' || allowed.includes(income.id)
    )
}


export function getTaxRegimesByIncomeCategory ( allTaxRegimes: FormSelectOption[], selectedIncomeCategory: string | null): FormSelectOption[] {
    if (!selectedIncomeCategory) return allTaxRegimes

    const allowed = filteredTaxRegimeByIncomeCategory[selectedIncomeCategory] || []
    return allTaxRegimes.filter(
        tax => tax.id === '' || allowed.includes(tax.id)
    )
}